import XCheckbox from "./common/XCheckbox";
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';

const IncludeIcd = () => {
    const { formik, updateCase } = useAddCaseFormContext();

    const onIsIcdIncludedChange = (e) => {
        const newValue = e.target.checked;
        formik.setFieldValue('isIcdIncluded', newValue);
        updateCase({ data: { isIcdIncluded: newValue } });
    }

    return (
        <XCheckbox
            name="isIcdIncluded"
            label="Include ICD codes in demand letter?"
            checked={formik.values.isIcdIncluded || false}
            onChange={onIsIcdIncludedChange}
        />
    )
}

export default IncludeIcd;
